<div class="db-notifier">
  <div [ngStyle]="{bottom: (20 + i * 70) + 'px'}" class="db-notifier__notification db-notifier__notification_{{notification.type}}" [ngClass]="{'db-notifier__notification_visible': notification.isVisible, 'extended-height': notification.extendHeight}" *ngFor="let notification of notifications; let i = index;">
    <!--<div class="db-notifier__notification-header" [innerHTML]="notification.title" *ngIf="notification.title"></div>-->

    <div class="db-notifier__notification-body">
      <span class="db-notifier__notification-icon" [ngSwitch]="notification.type">
        <img src="assets/images/common/checkmark_icon.svg" *ngSwitchCase="'success'" />
        <img src="assets/images/common/error_icon.svg" *ngSwitchCase="'danger'" />
        <i class="db-icon db-icon-ds-info-bg" *ngSwitchCase="'info'"></i>
<!--        <i class="db-icon db-icon-ds-exclamation-bg" *ngSwitchCase="'success'"></i>
        <i class="db-icon db-icon-ds-info-bg" *ngSwitchCase="'warning'"></i>
        <img src="assets/images/icons/close_error_icon-red.svg" *ngSwitchCase="'danger'" />-->
      </span>
      <span class="db-notifier__notification-message" [innerHTML]="notification.message"></span>
    </div>

    <a class="db-notifier__notification-close-button" (click)="removeNotification(notification)" *ngIf="notification.persist"><i class="db-icon db-icon-ds-close"></i></a>
  </div>
</div>
